import React, { useEffect, useState } from "react";
import {
  Spin,
  Table,
  Empty,
  Button,
  DatePicker,
  Select,
  Input,
  Tag,
} from "antd";
import { getLoggingOrder } from "../../../../apis/admin/loggingService";
import { combineUrlParams } from "./contsants";
import notificationHandler from "../../../atoms/Notification";
import { formatNumber } from "../../../helper";
import {
  DownloadOutlined,
  LoadingOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import "./Logging.scss"
import locale from "antd/es/date-picker/locale/vi_VN";
import { ColumnsType } from "antd/lib/table";
const LoggingOrders = () => {
  const [loading, setLoading] = useState(false);
  const [dataLogging, setDataLogging] = useState([]);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [totalElement, setTotalElement] = useState(0);
  const [valueInput, setValueInput] = useState({
    status: null,
    paymentStatus: null,
    phoneNumber: null,
    fromDate: "",
    toDate: "",
  });
  const { RangePicker } = DatePicker;
  const antIcon = (
    <LoadingOutlined style={{ fontSize: 70, position: "fixed" }} spin />
  );

  useEffect(() => {
    setLoading(true);
    const input = {
      ...valueInput,
      size: size,
      page: page,
    };
    getLoggingOrder(combineUrlParams(input))
      .then((res) => {
        setDataLogging(res?.data?.data?.payload?.content);
        setTotalElement(res?.data?.data?.payload?.totalElements);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  }, [size, page]);
  const handleFilter = () => {
    setLoading(true);
    const input = {
      ...valueInput,
      size: size,
      page: page,
    };
    getLoggingOrder(combineUrlParams(input))
      .then((res) => {
        setDataLogging(res?.data?.data?.payload?.content);
        setTotalElement(res?.data?.data?.payload?.totalElements);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    setLoading(true);
    getLoggingOrder(
      combineUrlParams({
        page,
        size,
      })
    )
      .then((res) => {
        setDataLogging(res?.data?.data?.payload?.content);
        setTotalElement(res?.data?.data?.payload?.totalElements);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  }, []);
  const displayedIndex = (index: any) => (page - 1) * size + index + 1;
  const columns: ColumnsType<any> = [
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      align: "center",
      className: " min-w-[40px] ",
      render: (_: any, __: any, index: any) => displayedIndex(index),
    },
    {
      title: "Số điện thoại",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      align: "center",
      className: " min-w-[150px] ",
    },
    {
      title: "SĐT tặng suất ăn",
      dataIndex: "targetPhoneNumber",
      key: "targetPhoneNumber",
      align: "center",
      className: " min-w-[150px] ",
    },
    {
      title: "Suất ăn",
      dataIndex: "menuType",
      key: "menuType",
      align: "center",
      render: (value: any) => {
        if (value === 1) {
          return <Tag color="magenta">Bữa sáng</Tag>;
        }
        if (value === 0) {
          return <Tag color="orange">Bữa trưa</Tag>;
        }
        if (value === 2) {
          return <Tag color="green">Bữa trưa đặc biệt</Tag>;
        }
      },
      className: " min-w-[150px] ",
    },
    {
      title: "Trạng thái thanh toán",
      dataIndex: "paymentStatus",
      key: "paymentStatus",
      align: "center",
      render: (value: any) => {
        if (value === 0) {
          return <Tag color="red">Chưa thanh toán</Tag>;
        } else if(value === 2){
          return <Tag color="red">Thanh toán không thành công</Tag>;
        } else {
          return <Tag color="green">Đã thanh toán</Tag>;
        }
      },
      className: " min-w-[180px] ",
    },
    {
      title: "Ngày đặt món",
      dataIndex: "orderDate",
      key: "orderDate",
      align: "center",
      // render: (value: any) => {
      //     return value.slice(0, 10)
      // },
      className: " min-w-[150px] ",
    },
    {
      title: "Giá tiền (VNĐ)",
      dataIndex: "mealPrice",
      key: "mealPrice",
      align: "center",
      render: (value: any) => {
        return formatNumber(value);
      },
      className: " min-w-[120px] ",
    },
    {
      title: "Trạng thái đơn hàng",
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (value: any) => {
        if (value === 0) {
          return <Tag color="red">Đã hủy</Tag>;
        }
        if (value === 1) {
          return <Tag color="orange">Đã đặt</Tag>;
        }
        if (value === 2) {
          return <Tag color="green">Đã ăn</Tag>;
        }
        if (value === 3) {
          return <Tag color="geekblue">Đã tặng</Tag>;
        }
        if (value === 4) {
          return <Tag color="purple">Đã chuyển</Tag>;
        }
        if (value === 5) {
          return <Tag color="purple">Đặt không thành công</Tag>;
        }
      },
      className: "min-w-[100px]",
    },
  ];
  const handleChangeStatus = (value: any) => {
    setValueInput({
      ...valueInput,
      status: value,
    });
  };
  const onchangeDate = (date: any, dateString: any) => {
    setValueInput({
      ...valueInput,
      fromDate: dateString[0],
      toDate: dateString[1],
    });
  };
  const handleChangePayment = (paymentStatus: any) => {
    setValueInput({
      ...valueInput,
      paymentStatus: paymentStatus,
    });
  };

  const handleChangePhoneNumber = (number: any) => {
    setValueInput({
      ...valueInput,
      phoneNumber: number,
    });
  };
  return (
    <div id="logging" className="px-[20px]">
      <Spin indicator={antIcon} spinning={loading} />
      <div>
        <div className="flex justify-between my-3">
          <div className="flex w-[70%]">
            <RangePicker
              onChange={onchangeDate}
              placeholder={["Chọn ngày bắt đầu ", "Chọn ngày kết thúc"]}
              // format={dateFormat}
              locale={locale}
              className="w-[30%] cursor-pointer"
            />
            <Input
              className="w-[25%] ml-3 items-center justify-center "
              placeholder="Số điện thoại"
              onChange={(e) => handleChangePhoneNumber(e.target.value)}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key.trim())) {
                  event.preventDefault();
                }
              }}
              allowClear
            ></Input>
            <Select
              className=" ml-3 w-[25%]"
              placeholder="Thao tác"
              labelInValue
              onChange={(e) => handleChangeStatus(e?.value)}
              allowClear
              options={[
                {
                  value: '',
                  label: "Chọn thao tác",
                },
                {
                  value: 1,
                  label: "Đã đặt",
                },
                {
                  value: 2,
                  label: "Đã ăn",
                },
                {
                  value: 0,
                  label: "Đã hủy",
                },
                {
                  value: 3,
                  label: "Đã tặng",
                },
                {
                  value: 4,
                  label: "Đã chuyển",
                },
              ]}
            />
            <Select
              className="ml-3 w-[25%]"
              placeholder="Trạng thái Thanh toán "
              labelInValue
              allowClear
              onChange={(e) => handleChangePayment(e?.value)}
              options={[
                {
                  value: '',
                  label: "Chọn trạng thái",
                },
                {
                  value: 1,
                  label: "Đã thanh toán",
                },
                {
                  value: 0,
                  label: "Chưa thanh toán",
                },
                {
                  value: 2,
                  label: "Thanh toán không thành công",
                },
              ]}
            />
            <Button
              icon={<SearchOutlined />}
              // loading={loading}
              onClick={handleFilter}
              className="ml-3 bg-cyan-500 hover:text-cyan-500 hover:bg-white hover:border-cyan-500 border-cyan-500 active:bg-cyan-500 focus:bg-cyan-500 focus:text-white text-white"
            >
              Tìm kiếm
            </Button>
          </div>
        </div>
      </div>
      <Table
        dataSource={dataLogging}
        columns={columns}
        pagination={{
          locale: { items_per_page: "bản ghi / Trang" },
          current: page,
          defaultPageSize: size,
          total: totalElement,
          onChange: (value: any) => setPage(value),
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50"],
          onShowSizeChange(current, size) {
            setSize(size);
          },
          showTotal: (total: any, range: any) => ` Tổng ${total} bản ghi`,
        }}
        rowKey={(record: any) => record.id}
        className="mt-[15px] overflow-auto"
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_DEFAULT}
              description="Không có dữ liệu!"
            />
          ),
        }}
      />
    </div>
  );
};

export default LoggingOrders;
